
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/locking-system/mechanic",
      function () {
        return require("private-next-pages/[locale]/locking-system/mechanic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/locking-system/mechanic"])
      });
    }
  